'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$35() {
}
export { $c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$35 as $c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$35 };
$c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$35.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$35.prototype.constructor = $c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$35;
/** @constructor */
function $h_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$35() {
}
export { $h_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$35 as $h_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$35 };
$h_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$35.prototype = $c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$35.prototype;
$c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$35.prototype.compose__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__compose__F1__F1(this, g);
});
$c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$35.prototype.andThen__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__andThen__F1__F1(this, g);
});
$c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$35.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$35.prototype.apply__O__O = (function(v1) {
  return v1;
});
$c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$35.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return v1;
});
var $d_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$35 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$35, "app.data.AcceptedRequestProvidedEPSCode$$anon$35", ({
  Lapp_data_AcceptedRequestProvidedEPSCode$$anon$35: 1,
  F1: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction1: 1
}));
export { $d_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$35 as $d_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$35 };
//# sourceMappingURL=app.data.-Accepted-Request-Provided-E-P-S-Code$$anon$35.js.map
